import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicReviews {
  constructor(section) {
    this.el = section.el;

    initCarousel(this.el, {
      perPage: 1,
      breakpoints: {
        [unitlessBreakpoints.sm]: {
          perPage: 2,
        },
        [unitlessBreakpoints.md]: {
          perPage: 3,
        },
        [unitlessBreakpoints.lg]: {
          perPage: 4,
        },
      },
    });
  }
}
